const BREATHWORK_IMAGE_MAP: Record<string, string> = {
  '4_7_8': '/breathworks/new/4_7_8@2x.png',
  'ANULOM_VILOM': '/breathworks/new/ANULOM_VILOM@2x.png',
  'BHASTRIKA': '/breathworks/new/BHASTRIKA@2x.png',
  'BHRAMARI': '/breathworks/new/BHRAMARI@2x.png',
  'CHANDRA_BHEDANA': '/breathworks/new/CHANDRA_BHEDANA@2x.jpg',
  'KAPALABHATI': '/breathworks/new/KAPALABHATI@2x.png',
  'KHECHARI_MUDRA': '/breathworks/new/KHECHARI_MUDRA@2x.png',
  'KUMBHAKA': '/breathworks/new/KUMBHAKA@2x.jpg',
  'MURCHA': '/breathworks/new/MURCHA@2x.png',
  'NADI_SHODHANA': '/breathworks/new/NADI_SHODHANA@2x.png',
  'PLAVINI': '/breathworks/new/PLAVINI@2x.png',
  'SAMA_VRITTI': '/breathworks/new/SAMA_VRITTI@2x.png',
  'SITALI': '/breathworks/new/SITALI@2x.jpg',
  'SITKARI': '/breathworks/new/SITKARI@2x.png',
  'SURYA_BHEDANA': '/breathworks/new/SURYA_BHEDANA@2x.png',
  'TUMMO': '/breathworks/new/TUMMO@2x.png',
  'UJJAYI': '/breathworks/new/UJJAYI@2x.jpg',
  'UDGITHA': '/breathworks/new/UDGITHA@2x.png',
  'VISHAMA_VRITTI': '/breathworks/new/VISHAMA_VRITTI@2x.png',
};

const BREATHWORK_IMAGE_2X_MAP: Record<string, string> = {
  '4_7_8': '/breathworks/new/4_7_8@4x.png',
  'ANULOM_VILOM': '/breathworks/new/ANULOM_VILOM@4x.png',
  'BHASTRIKA': '/breathworks/new/BHASTRIKA@4x.png',
  'BHRAMARI': '/breathworks/new/BHRAMARI@4x.png',
  'KAPALABHATI': '/breathworks/new/KAPALABHATI@4x.png',
  'KHECHARI_MUDRA': '/breathworks/new/KHECHARI_MUDRA@4x.png',
  'MURCHA': '/breathworks/new/MURCHA@4x.png',
  'NADI_SHODHANA': '/breathworks/new/NADI_SHODHANA@4x.png',
  'PLAVINI': '/breathworks/new/PLAVINI@4x.png',
  'SAMA_VRITTI': '/breathworks/new/SAMA_VRITTI@4x.png',
  'SITKARI': '/breathworks/new/SITKARI@4x.png',
  'SURYA_BHEDANA': '/breathworks/new/SURYA_BHEDANA@4x.png',
  'TUMMO': '/breathworks/new/TUMMO@4x.png',
  'UDGITHA': '/breathworks/new/UDGITHA@4x.png',
  'VISHAMA_VRITTI': '/breathworks/new/VISHAMA_VRITTI@4x.png',
};

export function breathworkImageUrl(id: string): string | null {
  return BREATHWORK_IMAGE_MAP[id] ?? null;
}

export function breathworkImageSrcSet(id: string): string | null {
  const imageUrl = BREATHWORK_IMAGE_MAP[id];
  if (!imageUrl) return null;

  const image2xUrl = BREATHWORK_IMAGE_2X_MAP[id];
  return image2xUrl ? `${imageUrl} 1x, ${image2xUrl} 2x` : null;
}

const BREATHWORK_NO_BG_IMAGE_MAP: Record<string, string> = {
  '4_7_8': '/breathworks/new/4_7_8_NO_BG_TRIMMED@2x.webp',
  'ANULOM_VILOM': '/breathworks/new/ANULOM_VILOM_NO_BG_TRIMMED@2x.webp',
  'BHASTRIKA': '/breathworks/new/BHASTRIKA_NO_BG_TRIMMED@2x.webp',
  'BHRAMARI': '/breathworks/new/BHRAMARI_NO_BG_TRIMMED@2x.webp',
  'CHANDRA_BHEDANA': '/breathworks/new/CHANDRA_BHEDANA_NO_BG_TRIMMED@2x.webp',
  'KAPALABHATI': '/breathworks/new/KAPALABHATI_NO_BG_TRIMMED@2x.webp',
  'KHECHARI_MUDRA': '/breathworks/new/KHECHARI_MUDRA_NO_BG_TRIMMED@2x.webp',
  'KUMBHAKA': '/breathworks/new/KUMBHAKA_NO_BG_TRIMMED@2x.webp',
  'MURCHA': '/breathworks/new/MURCHA_NO_BG_TRIMMED@2x.webp',
  'NADI_SHODHANA': '/breathworks/new/NADI_SHODHANA_NO_BG_TRIMMED@2x.webp',
  'PLAVINI': '/breathworks/new/PLAVINI_NO_BG_TRIMMED@2x.webp',
  'SAMA_VRITTI': '/breathworks/new/SAMA_VRITTI_NO_BG_TRIMMED@2x.webp',
  'SITALI': '/breathworks/new/SITALI_NO_BG_TRIMMED@2x.webp',
  'SITKARI': '/breathworks/new/SITKARI_NO_BG_TRIMMED@2x.webp',
  'SURYA_BHEDANA': '/breathworks/new/SURYA_BHEDANA_NO_BG_TRIMMED@2x.webp',
  'TUMMO': '/breathworks/new/TUMMO_NO_BG_TRIMMED@2x.webp',
  'UJJAYI': '/breathworks/new/UJJAYI_NO_BG_TRIMMED@2x.webp',
  'UDGITHA': '/breathworks/new/UDGITHA_NO_BG_TRIMMED@2x.webp',
  'VISHAMA_VRITTI': '/breathworks/new/VISHAMA_VRITTI_NO_BG_TRIMMED@2x.webp',
};

const BREATHWORK_NO_BG_IMAGE_2X_MAP: Record<string, string> = {
  '4_7_8': '/breathworks/new/4_7_8_NO_BG_TRIMMED@4x.webp',
  'ANULOM_VILOM': '/breathworks/new/ANULOM_VILOM_NO_BG_TRIMMED@4x.webp',
  'BHASTRIKA': '/breathworks/new/BHASTRIKA_NO_BG_TRIMMED@4x.webp',
  'BHRAMARI': '/breathworks/new/BHRAMARI_NO_BG_TRIMMED@4x.webp',
  'CHANDRA_BHEDANA': '/breathworks/new/CHANDRA_BHEDANA_NO_BG_TRIMMED@4x.webp',
  'KAPALABHATI': '/breathworks/new/KAPALABHATI_NO_BG_TRIMMED@4x.webp',
  'KHECHARI_MUDRA': '/breathworks/new/KHECHARI_MUDRA_NO_BG_TRIMMED@4x.webp',
  'KUMBHAKA': '/breathworks/new/KUMBHAKA_NO_BG_TRIMMED@4x.webp',
  'MURCHA': '/breathworks/new/MURCHA_NO_BG_TRIMMED@4x.webp',
  'NADI_SHODHANA': '/breathworks/new/NADI_SHODHANA_NO_BG_TRIMMED@4x.webp',
  'PLAVINI': '/breathworks/new/PLAVINI_NO_BG_TRIMMED@4x.webp',
  'SAMA_VRITTI': '/breathworks/new/SAMA_VRITTI_NO_BG_TRIMMED@4x.webp',
  'SITALI': '/breathworks/new/SITALI_NO_BG_TRIMMED@4x.webp',
  'SITKARI': '/breathworks/new/SITKARI_NO_BG_TRIMMED@4x.webp',
  'SURYA_BHEDANA': '/breathworks/new/SURYA_BHEDANA_NO_BG_TRIMMED@4x.webp',
  'TUMMO': '/breathworks/new/TUMMO_NO_BG_TRIMMED@4x.webp',
  'UJJAYI': '/breathworks/new/UJJAYI_NO_BG_TRIMMED@4x.webp',
  'UDGITHA': '/breathworks/new/UDGITHA_NO_BG_TRIMMED@4x.webp',
  'VISHAMA_VRITTI': '/breathworks/new/VISHAMA_VRITTI_NO_BG_TRIMMED@4x.webp',
};

export function breathworkNoBgImageUrl(id: string): string | null {
  return BREATHWORK_NO_BG_IMAGE_MAP[id] ?? null;
}

export function breathworkNoBgImageSrcSet(id: string): string | null {
  const imageUrl = BREATHWORK_NO_BG_IMAGE_MAP[id];
  if (!imageUrl) return null;

  const image2xUrl = BREATHWORK_NO_BG_IMAGE_2X_MAP[id];
  return image2xUrl ? `${imageUrl} 1x, ${image2xUrl} 2x` : null;
}
